'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  background-color: #54a9eb;\n  border-color: #54a9eb;\n\n  &:hover,\n  &:active {\n    background-color: #4b97d1;\n    border-color: #4b97d1;\n  }\n'], ['\n  background-color: #54a9eb;\n  border-color: #54a9eb;\n\n  &:hover,\n  &:active {\n    background-color: #4b97d1;\n    border-color: #4b97d1;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _factory = require('./factory');

var _factory2 = _interopRequireDefault(_factory);

var _telegram = require('../svg/telegram.js');

var _common = require('../common');

var _consts = require('../consts');

var _consts2 = _interopRequireDefault(_consts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Telegram = (0, _styledComponents2.default)(_common.SharingButton)(_templateObject);

exports.default = function (_ref) {
  var link = _ref.link,
      name = _ref.name,
      props = _objectWithoutProperties(_ref, ['link', 'name']);

  return _react2.default.createElement(_factory2.default, _extends({}, props, {
    name: name || 'Telegram',
    href: _consts2.default.telegram(link),
    buttonComponent: Telegram,
    iconFill: _telegram.TelegramIconFill,
    iconCircle: _telegram.TelegramIconCircle,
    iconCircleSolid: _telegram.TelegramIconCircleSolid
  }));
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-social-sharing/dist-modules/buttons/telegram.js
 ** module id = 1327
 ** module chunks = 0
 **/